// The widget's out-of-the-box look, and the fallback for every field a
// stored config leaves unset.
//
// Its own module because the dashboard's live card renders the same widget:
// importing this from index.jsx would pull the entire Customization page into
// the dashboard bundle.

export const defaultSettings = {
  name: "Hostor",
  // All four are the brand colour, so a fresh assistant is a single flat
  // colour out of the box rather than a gradient of shades.
  primaryColor: "#3F44E8",
  headerColor: "#3F44E8",
  accentColor: "#3F44E8",
  buttonColor: "#3F44E8",
  fontFamily: "Inter",
  fontSize: 15,
  messageSize: "Medium",
  nameStyle: "Bold",
  // Lucide's Bot glyph, used whenever the record has no launcher style set.
  launcherStyle: "lucide:Bot",
  avatarImage: null,
  widgetPosition: "right",
  // Only read when widgetPosition is "custom": the free placement, as a
  // percentage of the viewport. See widgetPlacement.js.
  widgetOffsetX: 92,
  widgetOffsetY: 88,
  borderRadius: 16,
  bubbleStyle: "rounded",
  theme: "light",
  spacing: "comfortable",
  welcomeMessage: "Hi! I'm Hostor 👋\nHow can I help you today?",
  quickActions: ["Pricing", "Book a demo", "Features"],
  showPoweredBy: true,
  showOnlineStatus: true,
  isAuthorizationRequired: false,
  showSourceLinks: true,
  // Widget behavior. Not part of the widgetTheme schema yet, so these are
  // edited here but not sent on save - see the note in mapConfig.
  initialState: "Minimized",
  autoOpenAfter: "5 seconds",
  showWelcomeMessage: true,
  showAvatar: true,
  allowClose: true,
};
